import { Flex, Grid, HStack, Text } from "@chakra-ui/react";
import { GRAY_800 } from "utils/colors";
import { useCustomFormats } from "hooks/useCustomFormat";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { Badge } from "./badge";

export function Header() {
  const { formatCurrency } = useCustomFormats();

  const CardTitle = ({
    children,
    color = "default",
    percentage = 0,
  }: {
    children: React.ReactNode;
    color?: "default" | "green";
    percentage?: number | undefined;
  }) => {
    const colorMap = {
      default: "black",
      green: "#45C14A",
    };

    return (
      <HStack gap={2} justifyContent="space-between" alignItems="flex-start">
        <Text fontSize="2xl" fontWeight="semibold" color={colorMap[color]}>
          {children}
        </Text>
        {percentage !== undefined && percentage !== null && (
          <Badge colorScheme="success">
            {percentage >= 0 ? "+" : "-"}
            {percentage.toFixed(2)}%
          </Badge>
        )}
      </HStack>
    );
  };

  const TotalTransactionVolume = () => {
    return (
      <WidgetBox flex="1">
        <CardTitle percentage={0}>{formatCurrency(5000000)}</CardTitle>
        <Text fontSize="sm" fontWeight="semibold" color="black">
          Total Transaction Volume
        </Text>
        <Text fontSize="xs" fontWeight="medium" color={GRAY_800}>
          0 Transactions
        </Text>
      </WidgetBox>
    );
  };

  const AuthorizationRate = () => {
    return (
      <WidgetBox flex="1">
        <CardTitle color="green" percentage={0}>
          98%
        </CardTitle>
        <Text fontSize="sm" fontWeight="semibold" color="black">
          Authorization Rate
        </Text>
        <Text fontSize="xs" fontWeight="medium" color={GRAY_800}>
          0 Transactions
        </Text>
      </WidgetBox>
    );
  };

  const Pipeline = () => {
    return (
      <WidgetBox flex="1">
        <CardTitle percentage={0}>{formatCurrency(2000000)}</CardTitle>
        <Text fontSize="sm" fontWeight="semibold" color="black">
          Pipeline
        </Text>
        <Text fontSize="xs" fontWeight="medium" color={GRAY_800}>
          0 in Pipeline
        </Text>
      </WidgetBox>
    );
  };

  const PipelineStatus = () => {
    return (
      <WidgetBox flex="1">
        <CardTitle percentage={0}>{formatCurrency(2000000)}</CardTitle>
        <Text fontSize="sm" fontWeight="semibold" color="black">
          Pipeline
        </Text>
        <Flex gap={1}>
          <Text fontSize="xs" fontWeight="medium" color="#45C14A">
            +3%
          </Text>
          <Text fontSize="xs" fontWeight="medium" color={GRAY_800}>
            from last month
          </Text>
        </Flex>
      </WidgetBox>
    );
  };

  return (
    <Grid
      templateColumns={{
        base: "1fr",
        xl: "repeat(4, 1fr)",
      }}
      gap={4}
    >
      <TotalTransactionVolume />
      <AuthorizationRate />
      <Pipeline />
      <PipelineStatus />
    </Grid>
  );
}
